module.exports = __webpack_public_path__ + "img/MES6VideoThumbnail.52e9d69c.png";